<template>
  <div
    class="block block-fx-pop"
    v-observe-visibility="visibilityChanged"
    v-if="!called || filteredPosts.length > 0"
  >
    <!-- v-show="!called || (called && links.length > 0)"> -->
    <div class="block-header block-header-default">
      <h3 class="block-title">{{ blog.name }}</h3>
    </div>
    <div class="block-content">
      <p v-if="filteredPosts.length === 0">Geen links gevonden!</p>
      <table class="table table-sm table-hover table-vcenter" v-if="filteredPosts.length > 0">
        <thead>
          <tr>
            <th style="width: 30px" class="text-center">
              <div class="custom-control custom-checkbox d-inline-block">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="blog.id + '-all'"
                  :name="blog.id + '-all'"
                  :checked="allSelected"
                  v-on:change.prevent="selectAllPosts"
                />
                <label class="custom-control-label" :for="blog.id + '-all'"></label>
              </div>
            </th>
            <th style="width: 130px" class="d-none d-sm-table-cell">Pagina</th>
            <th>Titel</th>
            <th style="width: 130px" class="d-none d-sm-table-cell">Startdatum</th>
            <th style="width: 130px" class="d-none d-sm-table-cell">Status</th>
            <th style="width: 80px" class="text-right">Acties</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="post in filteredPosts" :key="post.id">
            <td class="text-center">
              <div class="custom-control custom-checkbox d-inline-block">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="blog.id + '-post-' + post.id"
                  :name="blog.id + '-post-' + post.id"
                  :checked="selectedPost(post)"
                  v-on:change.prevent="selectPost(post)"
                />
                <label class="custom-control-label" :for="blog.id + '-post-' + post.id"></label>
              </div>
            </td>
            <td class="d-none d-sm-table-cell">{{ post.page.title }}</td>
            <td class="text-truncate">
              {{ post.title | capitalize }}
            </td>
            <td class="d-none d-sm-table-cell">{{ post.started_at ? moment(post.started_at).format('DD-MM-YYYY') : 'n.v.t.' }}</td>
            <td class="d-none d-sm-table-cell" :class="statusclass(post)">{{ post.status_name }}</td>
            <td class="text-right">
              <a
                v-if="[3, 4].includes(post.status)"
                class="mr-1"
                :href="`https://${blog.name}/${post.slug}`"
                data-toggle="tooltip"
                data-placement="top"
                title="Bericht bekijken"
                data-original-title="Bericht bekijken"
                target="_blank"
              >
                <i class="fa fa-fw fa-eye"></i>
              </a>
              <a
                :href="$route('posts.edit', blog.id, post.id)"
                data-toggle="tooltip"
                data-placement="top"
                title="Bericht bewerken"
                data-original-title="Bericht bewerken"
              >
                <i class="fa fa-fw fa-pencil-alt"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import axios from 'axios';
import Fuse from 'fuse.js';

export default {
  props: {
    blog: {
      required: true,
    },
    selectedPosts: {
      required: true,
      default: () => [],
    },
    selectedFilters: {
      required: true,
      default: [],
    },
  },
  data: () => {
    return {
      called: false,
      isVisible: false,
      posts: [],
      filteredPosts: [],
    };
  },
  computed: {
    allSelected: function() {
      var blogSelectedPosts = this.selectedPosts.filter((spost) => spost.blog.id === this.blog.id);
      return blogSelectedPosts.length === this.filteredPosts.length;
    },
  },
  watch: {
    isVisible: function() {
      if (this.isVisible) {
        this.getData();
      }
    },
    selectedFilters: function() {
      this.applyFilters();
    },
  },
  methods: {
    statusclass(post) {
      switch (post.status) {
        default:
          return '';
          break;
      }
    },
    selectedPost(post) {
      var index = _.findIndex(this.selectedPosts, (spost) => {
        return spost.blog.id === this.blog.id && spost.id === post.id;
      });
      return index >= 0;
    },
    visibilityChanged(isVisible, entry) {
      if (!this.isVisible) {
        this.isVisible = isVisible;
      }
    },
    getData() {
      this.posts = this.blog.posts
        .filter((post) => !post.user_package_id)
        .map((post) => {
          post.links = this.getLinks(post);
          return post;
        });
      this.applyFilters();
      this.called = true;
    },
    getLinks(post) {
      var links = post.content.match(/href=[\'"]?([^\'" >]+)/gm);
      if (!links) return [];

      links = links.map((link) => {
        link = link.replace('href="', '');

        var prefix = 'https://';
        if (link.substr(0, prefix.length) !== prefix)
        {
            link = prefix + link;
        }
        return this.getDomainFromUrl(link);
      });

      return _.uniq(links);
    },
    applyFilters() {
      let posts = this.posts;
      let combinedFilters = [];
      this.selectedFilters
        .filter((selectedFilter) => selectedFilter.key !== 'blog')
        .forEach((selectedFilter) => {
          var index = _.findIndex(combinedFilters, (cFilter) => {
            return cFilter.key === selectedFilter.key;
          });

          if (index >= 0) {
            combinedFilters[index].values.push(selectedFilter.value);
          } else {
            combinedFilters.push({
              key: selectedFilter.key,
              values: Array.isArray(selectedFilter.value) ? selectedFilter.value : [selectedFilter.value],
            });
          }
        });

      combinedFilters
        .filter((selectedFilter) => selectedFilter.key !== 'search')
        .forEach((filter) => {
          posts = posts.filter((post) => {
            return post[filter.key] && filter.values.includes(post[filter.key]);
          });
        });

      this.filteredPosts = posts;
      this.applySearch(combinedFilters);
    },
    applySearch(combinedFilters) {
      var fuse = new Fuse(this.filteredPosts, {
        threshold: 0.2,
        includeScore: false,
        useExtendedSearch: true,
        keys: ['title', 'links'],
      });
      combinedFilters
        .filter((selectedFilter) => selectedFilter.key === 'search')
        .forEach((filter) => {
          this.filteredPosts = fuse.search(filter.values.join('|')).map((result) => {
            return result.item;
          });
        });
    },
    selectPost(post, remove = true) {
      var index = _.findIndex(this.selectedPosts, (spost) => {
        return spost.blog.id === this.blog.id && spost.id === post.id;
      });

      if (index >= 0) {
        if (remove) {
          this.selectedPosts.splice(index, 1);
        }
      } else {
        post.blog = this.blog;
        this.selectedPosts.push(post);
      }

      this.$set(this.selectedPosts, this.selectedPosts);
    },
    selectAllPosts() {
      if (this.allSelected) {
        this.filteredPosts.forEach((post) => {
          this.selectPost(post);
        });
      } else {
        this.filteredPosts.forEach((post) => {
          this.selectPost(post, false);
        });
      }
    },
    getDomainFromUrl: function(url) {
      const { host } = new URL(url);
      return host.split('.').length > 2
        ? host
            .split('.')
            .splice(1)
            .join('.')
        : host;
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  table-layout: fixed;

  tbody {
    tr {
      height: 47px;
    }
  }
}
</style>
